export const gridSize = 11
export const squareSize = window.innerWidth < 576 ? 33 : 50
